import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { BreadCrumbs } from './BreadCrumbs';

export class Headerbar extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={css(Styles.container)}>
        <Grid container className={css(Styles.containerNarrow)}>
          <Grid item sm={6} xs={6}>
            <h1 className={css(Styles.title)}>{this.props.title}</h1>
            <BreadCrumbs breadCrumbs={this.props.breadCrumbs} />
          </Grid>
          <Grid item sm={6} xs={6} className={css(Styles.containerButton)}>
            {this.props.actionComponents && this.props.actionComponents.map((actionComponent, index) => {
              return (
                <div key={'actionComponent_' + index} className={css(Styles.actionComponent)}>
                  {actionComponent}
                </div>
              )
            })}
            {this.props.actions && this.props.actions.map((actionItem, index) => {
              return (
                <Button
                  key = {index}
                  className = {css(Styles.button)}
                  variant='contained' color='primary' onClick={actionItem.onClick}>
                  <i className='material-icons'>add_circle_outline</i>
                  <span className={css(Styles.buttonLabel)}>{actionItem.label}</span>
                </Button>
              )
            })}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  container: {
    position: 'fixed',
    top: AppTheme.toolbarHeight,
    height: AppTheme.toolbarHeight,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    marginBottom: 5,
    zIndex: 1000
  },
  containerNarrow: {
    maxWidth: AppTheme.viewPort,
  },
  title: {
    color: 'black',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: 24,
    marginBottom: 5
  },
  containerButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  actionComponent: {
    marginLeft : 10
  },
  button: {
    boxShadow: 'none',
    marginLeft : 10
  },
  buttonLabel: {
    marginLeft: 4
  }
})


// WEBPACK FOOTER //
// ./src/common/components/Headerbar.js